import { render, staticRenderFns } from "./BannerRed.vue?vue&type=template&id=d46476ae&scoped=true&"
import script from "./BannerRed.vue?vue&type=script&lang=js&"
export * from "./BannerRed.vue?vue&type=script&lang=js&"
import style0 from "./BannerRed.vue?vue&type=style&index=0&id=d46476ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46476ae",
  null
  
)

export default component.exports